<template>
  <div class="top-header">
    <div class="navbar">
      <div class="left-panel">
        <span class="welcome-text">欢迎进入 <b>森林综合管理可视化系统</b></span>
      </div>

      <div class="right-panel">
        <el-tooltip content="刷新页面" placement="bottom">
          <div class="btn-refresh" @click="refreshPage">
            <i class="el-icon-refresh"></i>
          </div>
        </el-tooltip>

        <div @click="handleechrts">
          <el-avatar
            :size="35"
            :src="echrtsUrl"
            class="user-avatar"
          ></el-avatar>
        </div>

        <!-- <el-avatar :size="35" :src="avatarUrl" class="user-avatar"></el-avatar> -->

        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <span class="username">{{ rolename }}</span>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="password" icon="el-icon-lock"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item command="logout" divided>
              <i class="el-icon-close" style="font-weight: bold"></i> 退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="tags-view-container">
      <div
        v-for="(tag, index) in tags"
        :key="tag.path"
        class="tag-item"
        :class="{ active: isActive(tag) }"
        @click="handleTagClick(tag)"
      >
        {{ tag.title }}
        <span
          v-if="tag.path !== '/database'"
          class="close-icon"
          @click.stop="closeTag(index, tag)"
          >×</span
        >
      </div>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form
        :model="passwordForm"
        :rules="rules"
        ref="passwordForm"
        label-width="80px"
      >
        <el-form-item label="账号" prop="username">
          <el-input v-model="passwordForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="passwordForm.password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="passwordForm.confirmPassword"
            placeholder="请再次输入密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { editUser, getUserinfo } from "@/api/user/index";
export default {
  name: "TopHeader",
  data() {
    // 自定义验证规则：校验两次密码是否一致
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      id: "",
      rolename: "",
      avatarUrl: require("@/assets/logo.png"),
      echrtsUrl: require("@/assets/echrts.png"),
      tags: [{ title: "数据库", path: "/database" }],

      // --- 修改密码相关数据 ---
      dialogVisible: false,
      loading: false, // 按钮加载状态
      passwordForm: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    $route: {
      handler(newRoute) {
        this.addTags(newRoute);
      },
      immediate: true,
    },
  },
  mounted() {
    this.getUserinfo();
  },
  methods: {
    handleechrts() {
      this.$router.push({ path: this.redirect || "/big-screen" });
    },
    getUserinfo() {
      getUserinfo({ _from: "top_header" }).then((res) => {
        if (res.code == 200) {
          // this.passwordForm.username = res.data.mobile;
          this.id = res.data.id;
          this.rolename = res.data.roles[0].name || "";
        }
      });
    },
    refreshPage() {
      window.location.reload();
    },

    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else if (command === "password") {
        this.openPasswordDialog();
      }
    },

    // --- 打开修改密码弹窗 ---
    openPasswordDialog() {
      // 1. 获取本地存储的用户信息
      // 注意：如果存的是JSON对象，请使用 JSON.parse(localStorage.getItem('user')).username
      const user = localStorage.getItem("user") || "Admin";

      this.passwordForm.username = user;
      this.dialogVisible = true;
    },

    // --- 提交修改密码 ---
    submitPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 模拟接口参数
          const params = {
            username: this.passwordForm.username,
            password: this.passwordForm.password,
            id: this.id,
          };
          this.loading = false;
          editUser(params).then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.$message.success("密码修改成功，请重新登录");
                this.dialogVisible = false;
                localStorage.removeItem("token");
                localStorage.removeItem("user"); // 也可以顺便清除用户信息
                this.$router.push("/login");
                // 修改成功后通常需要退出登录
                this.logoutDirectly();
              }, 1000);
            }
          });
        } else {
          console.log("表单校验失败");
          return false;
        }
      });
    },

    // --- 重置表单 (关闭弹窗时触发) ---
    resetForm() {
      this.$refs.passwordForm.resetFields();
      this.passwordForm.password = "";
      this.passwordForm.confirmPassword = "";
      this.loading = false;
    },

    // --- 退出登录逻辑 (带确认) ---
    logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.logoutDirectly();
        })
        .catch(() => {});
    },

    // --- 直接退出 (用于修改密码成功后) ---
    logoutDirectly() {
      localStorage.removeItem("token");
      localStorage.removeItem("user"); // 也可以顺便清除用户信息
      this.$router.push("/login");
    },

    // --- Tags 相关逻辑 ---
    isActive(tag) {
      return tag.path === this.$route.path;
    },
    addTags(route) {
      const { name } = route;
      if (!name) return;
      const isExist = this.tags.some((item) => item.path === route.path);
      if (!isExist) {
        this.tags.push({
          title: route.meta.title || "未命名",
          path: route.path,
        });
      }
    },
    handleTagClick(tag) {
      this.$router.push(tag.path);
    },
    closeTag(index, tag) {
      this.tags.splice(index, 1);
      if (this.isActive(tag)) {
        const lastTag = this.tags[this.tags.length - 1];
        if (lastTag) {
          this.$router.push(lastTag.path);
        } else {
          this.$router.push("/");
        }
      }
    },
  },
};
</script>

<style scoped>
.top-header {
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  flex-direction: column;
}

.navbar {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f0;
}

.right-panel {
  display: flex;
  align-items: center;
  height: 100%;
}

.btn-refresh {
  font-size: 20px;
  color: #5a5e66;
  cursor: pointer;
  margin-right: 20px;
  transition: transform 0.3s;
}

.btn-refresh:hover {
  transform: rotate(180deg);
  color: #409eff;
}

.user-avatar {
  margin-right: 10px;
  cursor: pointer;
}

.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #333;
}
.el-dropdown-link:hover {
  color: #409eff;
}

.username {
  font-size: 14px;
  font-weight: 500;
}

.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.tag-item {
  display: inline-block;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 2px;
  cursor: pointer;
}
.tag-item.active {
  background-color: #eafff5;
  color: #42b983;
  border-color: #eafff5;
}
.close-icon {
  margin-left: 5px;
  font-size: 12px;
}
.close-icon:hover {
  background-color: #b4bccc;
  color: #fff;
  border-radius: 50%;
}
</style>
